import { HttpClient } from '@angular/common/http';
import { LogLevel } from '../../models/LogLevel';
import { AbstractTransporter } from '../AbstractTransporter';
import { LogMessage } from '../../models/ILogger';
import { TransportTemplate } from '../TransportTemplate';
import { SlackNotificationService, SlackRequestBody } from '../../../../services/slack-notification.service';

export interface SlackTransporterConfig {
    url: string;
}

/**
 * Http Transporter
 */
export class SlackTransporter<T = LogMessage> extends AbstractTransporter<T> {
    constructor(
        template: TransportTemplate<T>,
        private httpClient: HttpClient,
        private slackNotificationService: SlackNotificationService
    ) {
        super(template);
    }

    /**
     * Writes/sends payload to configured url and given Http Method
     */
    doWrite(payload: T, level: LogLevel): void {
        this.slackNotificationService.sendBufferedDynamicMessage((payload as any).payload);
    }

    private isPrimitive(message: any): boolean {
        return (
            typeof message === 'string' ||
            typeof message === 'number' ||
            typeof message === 'boolean' ||
            typeof message == null ||
            message instanceof Date ||
            typeof message === 'function'
        );
    }
}
